// extracted by mini-css-extract-plugin
export default {"error":"NaoEncontrada_error__IhxsV","botaoRedirecionar":"NaoEncontrada_botaoRedirecionar__4p3Jp"};